import { Carousel as CarouselBootstrap } from "react-bootstrap";

import { Image } from "./Image.tsx";
import placeholderPhoto from "../../assets/img/placeholder.svg";
import { useGetFile } from "../../hooks/useGetFile.tsx";

interface CarouselProps {
  id: string;
  paths: string[];
}

export const Carousel = ({ id, paths }: CarouselProps) => {
  const { data: photos } = useGetFile({
    enabled: paths?.length > 0,
    listFiles: paths,
    keys: ["carousel", "photos", id],
  });

  return (
    <CarouselBootstrap
      className="pssPhotos overflow-hidden propertyCarousel"
      interval={null}
    >
      {paths?.length > 0 ? (
        photos?.urls!.map((url, index) => {
          return (
            <CarouselBootstrap.Item key={index} className="p-0">
              <Image
                className="d-block w-100 h-100"
                src={url}
                alt="Photo"
                style={{
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </CarouselBootstrap.Item>
          );
        })
      ) : (
        <CarouselBootstrap.Item key={0} className="p-0">
          <Image
            className="d-block w-100 h-100"
            src={placeholderPhoto}
            alt="Photo"
            style={{
              maxHeight: "500px",
              objectFit: "cover",
            }}
          />
        </CarouselBootstrap.Item>
      )}
    </CarouselBootstrap>
  );
};
